// extracted by mini-css-extract-plugin
export default {"productGallery":"eK-z","inQuickShop":"fK-z"};